import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import RouterUpdate from './components/common/RouterUpdate';
import store from './store';
import { Provider } from 'react-redux';

import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer/Footer';
import Sidenav from './components/layout/Sidenav/Sidenav';
import Theme from './components/layout/Theme/Theme';
import Home from './components/Home/Home';
import Posts from './components/Posts/PostsContainer';
import Post from './components/Posts/PostContainer';
import About from './components/About/AboutContainer';
import Methodology from './components/Methodology/MethodologyContainer';
import Course from './components/Course/CourseContainer';
import Contact from './components/Contact/ContactContainer';
import DataPolicies from './components/DataPolicies/DataPoliciesContainer';


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Theme>
          <Router>
            <div className="App">
              <RouterUpdate />
              <Header />
              <Sidenav />

              <div className="content">
                <Switch>
                  <Route exact path="/rolam" component={About} />
                  <Route exact path="/modszertan" component={Methodology} />
                  <Route exact path="/blog" component={Posts} />
                  <Route exact path="/blog/:slug" component={Post} />
                  <Route exact path="/kurzus/:slug" component={Course} />
                  <Route exact path="/kapcsolat" component={Contact} />
                  <Route exact path="/adatkezeles" component={DataPolicies} />
                  <Route path="/" component={Home} />
                </Switch>
              </div>

              <Footer />
            </div>
          </Router>
        </Theme>
      </Provider>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js